import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { map, take } from 'rxjs/operators';
import { IDelete } from '../models/deleted';
import { News } from '../models/news';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {

  constructor(private firestore: AngularFirestore) { }

  create<T>(collection:string, element: T){
    return this.firestore.collection<T>(collection).add({...element});
  }

  read2<T extends IDelete>(coleccion: string) {
    return this.firestore.collection<T>(coleccion).stateChanges()
      .pipe(
          map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as T;
          const id = a.payload.doc.id;
          return { id, ...data };
        }).filter(item => !item.deleted);;
      })
    ).pipe(take(1)).toPromise();
  }

  readNews(colecction:string){
    return this.firestore.collection<News>(colecction, (ref) =>
      ref.where('deleted', '==', false)
      .orderBy('createdAt', 'desc')
      .limit(80)
    ).stateChanges()
    .pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data();
          data.id = a.payload.doc.id;
          return data;
        })
      })
    ).pipe(take(1)).toPromise();
  }
}
